export default __webpack_public_path__ + "static/media/ug.28f28e8b.jpg";